(function () {
    const track = document.getElementById('slider-track');
    if (!track) return;

    const dots = document.querySelectorAll('.gallery-dot');
    const imgs = track.querySelectorAll('img');
    const totalSlides = imgs.length;
    let idx = 0;

    function goTo(i) {
        idx = (i + totalSlides) % totalSlides;
        track.style.transform = `translateX(-${idx * 100}%)`;
        dots.forEach((d, n) => d.classList.toggle('bg-volt-400', n === idx));
        dots.forEach((d, n) => d.classList.toggle('bg-white/30', n !== idx));
    }

    const prev = document.getElementById('slider-prev');
    const next = document.getElementById('slider-next');
    if (prev) prev.onclick = () => goTo(idx - 1);
    if (next) next.onclick = () => goTo(idx + 1);
    dots.forEach(d => d.onclick = () => goTo(+d.dataset.index));

    let startX = 0;
    track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
    track.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) goTo(idx + (diff > 0 ? 1 : -1));
    });

    const lb = document.getElementById('lightbox');
    const lbImg = document.getElementById('lb-image');
    const lbCounter = document.getElementById('lb-counter');
    const lbDots = document.querySelectorAll('.lb-dot');
    if (!lb || !lbImg || !lbCounter) return;

    let lbIdx = 0;
    const srcs = Array.from(imgs).map(i => i.src);

    function lbGo(i) {
        lbIdx = (i + totalSlides) % totalSlides;
        lbImg.src = srcs[lbIdx];
        lbCounter.textContent = `${lbIdx + 1} / ${totalSlides}`;
        lbDots.forEach((d, n) => d.classList.toggle('bg-volt-400', n === lbIdx));
        lbDots.forEach((d, n) => d.classList.toggle('bg-white/30', n !== lbIdx));
    }

    imgs.forEach(img => img.onclick = () => {
        lbGo(+img.dataset.index);
        lb.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    });

    const lbClose = document.getElementById('lb-close');
    const lbPrev = document.getElementById('lb-prev');
    const lbNext = document.getElementById('lb-next');

    if (lbClose) lbClose.onclick = () => {
        lb.classList.add('hidden');
        document.body.style.overflow = '';
    };
    if (lbPrev) lbPrev.onclick = () => lbGo(lbIdx - 1);
    if (lbNext) lbNext.onclick = () => lbGo(lbIdx + 1);
    lbDots.forEach(d => d.onclick = () => lbGo(+d.dataset.index));

    lb.onclick = e => { if (e.target === lb && lbClose) lbClose.click(); };

    document.addEventListener('keydown', e => {
        if (lb.classList.contains('hidden')) return;
        if (e.key === 'Escape' && lbClose) lbClose.click();
        if (e.key === 'ArrowLeft') lbGo(lbIdx - 1);
        if (e.key === 'ArrowRight') lbGo(lbIdx + 1);
    });

    let lbStartX = 0;
    lb.addEventListener('touchstart', e => { lbStartX = e.touches[0].clientX; });
    lb.addEventListener('touchend', e => {
        const diff = lbStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) lbGo(lbIdx + (diff > 0 ? 1 : -1));
    });
})();

(function () {
    const revImgs = document.querySelectorAll('#reviews .grid img');
    const rlb = document.getElementById('review-lb');
    const rlbImg = document.getElementById('rlb-img');
    const rlbUser = document.getElementById('rlb-user');
    const rlbStars = document.getElementById('rlb-stars');
    const rlbCounter = document.getElementById('rlb-counter');
    if (!rlb || !rlbImg || !rlbUser || !rlbStars || !rlbCounter || !revImgs.length) return;

    const total = revImgs.length;
    let rIdx = 0;

    function updateRlb() {
        const img = revImgs[rIdx];
        rlbImg.src = img.src;
        rlbUser.textContent = img.dataset.user || '';
        const rating = parseInt(img.dataset.rating, 10) || 5;
        rlbStars.innerHTML = '<i class="fas fa-star"></i>'.repeat(rating);
        rlbCounter.textContent = `${rIdx + 1} / ${total}`;
    }

    window.openReviewLb = function (i) {
        rIdx = i;
        updateRlb();
        rlb.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    };

    window.closeReviewLb = function () {
        rlb.classList.add('hidden');
        document.body.style.overflow = '';
    };

    const rlbBack = document.getElementById('rlb-back');
    const rlbPrev = document.getElementById('rlb-prev');
    const rlbNext = document.getElementById('rlb-next');

    if (rlbBack) rlbBack.onclick = closeReviewLb;
    if (rlbPrev) rlbPrev.onclick = () => { rIdx = (rIdx - 1 + total) % total; updateRlb(); };
    if (rlbNext) rlbNext.onclick = () => { rIdx = (rIdx + 1) % total; updateRlb(); };
    rlb.onclick = e => { if (e.target === rlb) closeReviewLb(); };

    document.addEventListener('keydown', e => {
        if (rlb.classList.contains('hidden')) return;
        if (e.key === 'Escape') closeReviewLb();
        if (e.key === 'ArrowLeft') { rIdx = (rIdx - 1 + total) % total; updateRlb(); }
        if (e.key === 'ArrowRight') { rIdx = (rIdx + 1) % total; updateRlb(); }
    });

    let rlbStartX = 0;
    rlb.addEventListener('touchstart', e => { rlbStartX = e.touches[0].clientX; });
    rlb.addEventListener('touchend', e => {
        const diff = rlbStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) { rIdx = (rIdx + (diff > 0 ? 1 : -1) + total) % total; updateRlb(); }
    });
})();

function toggleFaq(btn) {
    const item = btn.parentElement;
    if (!item) return;
    const content = item.querySelector('.faq-content');
    const icon = btn.querySelector('i');
    if (!content || !icon) return;
    const isOpen = !content.classList.contains('hidden');

    document.querySelectorAll('.faq-item').forEach(el => {
        const c = el.querySelector('.faq-content');
        const i = el.querySelector('i');
        if (c) c.classList.add('hidden');
        if (i) i.classList.remove('rotate-45');
    });

    if (!isOpen) {
        content.classList.remove('hidden');
        icon.classList.add('rotate-45');
    }
}
